const version = window.buildNumber;

export const initNewRelicBrowserMonitoring = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const newrelic = (window.newrelic = (window as any).newrelic || {});

  newrelic.setCustomAttribute('buildNumber', version);
  newrelic.setCustomAttribute('env', process.env.GATSBY_ENV);
  newrelic.addRelease('marcom', version);
};
